import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

export default function Layout({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative min-h-screen flex overflow-hidden">

      {/* 🔷 WATERMARK — KEEP ON TOP OF BACKGROUND, BELOW CONTENT */}
      <div
        className="
          absolute inset-0 flex items-end justify-center 
          pointer-events-none select-none opacity-20 mb-5
        "
        style={{
          fontSize: "0.8rem",
          fontWeight: "700",
          color: "#1e40af",
          transform: "rotate(0deg)",
          zIndex: 1,  // 👈 important
        }}
      >
        <p>© Powered by <span>Synoweb Technology</span> 2025</p>
      </div>

      {/* 🔷 SIDEBAR */}
      <Sidebar isOpen={isOpen} onClose={() => setIsOpen(false)} />

      {/* 🔷 MAIN CONTENT */}
      <div className="flex-1 relative z-20">
        <Navbar onMenuClick={() => setIsOpen(!isOpen)} />
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
